import { toast } from 'sonner';

export const Toasts = {
  success: (message) => {
    const data =
      typeof message === 'string'
        ? message
        : message?.[0]?.message || 'some error occoured';
    return toast.success(data, {
      position: 'bottom-center',
      richColors: true
    });
  },

  error: (message) => {
    const data =
      typeof message === 'string'
        ? message
        : message?.[0]?.message || 'some error occoured';
    return toast.error(data, {
      position: 'bottom-center'
    });
  },

  warn: (message) => {
    const data =
      typeof message === 'string'
        ? message
        : message?.[0]?.message || 'some error occoured';
    return toast.warn(data, {
      position: 'bottom-center'
    });
  },

  info: (message) => {
    const data =
      typeof message === 'string'
        ? message
        : message?.[0]?.message || 'some error occoured';
    return toast.info(data, {
      position: 'bottom-center'
    });
  }
};
